import { createReducer } from '@reduxjs/toolkit'

import { ActiveTablesTypes, PlayerPrivacyStatusesEnum } from 'shared/models/LastWins'

import * as actions from '../actions'
import { ILastWinsState } from '../types'

const initialState: ILastWinsState['data'] = {
  privacySettings: {
    hideMode: PlayerPrivacyStatusesEnum.none,
    isNickHidden: false,
    activeTables: [],
  },
  currentActiveTable: ActiveTablesTypes.standard,
  slotsWinsPage: 1,
  slotsWinsPageSize: 10,
  // slotsWinsTableType: tableTypesEnum.lastBets,
  slotsWins: {
    page: 1,
    count: 0,
    wins: [],
  },
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getSlotsLastWins.success, (state, action) => {
      if (action.payload) {
        state.slotsWins.wins = action.payload.wins
        state.slotsWins.count = action.payload.count
      }
    })
    .addCase(actions.getPlayerPrivacySettings.success, (state, action) => {
      if (action.payload) {
        state.privacySettings = action.payload
      }
    })
    .addCase(actions.updateSlotsLastWinsPage, (state, action) => {
      if (action.payload) {
        state.slotsWinsPage = action.payload
      }
    })
    .addCase(actions.changeActiveWinsTable, (state, action) => {
      state.currentActiveTable = action.payload
    })
    .addCase(actions.updateSlotsLastWinsPageSize, (state, action) => {
      if (action.payload) {
        state.slotsWinsPageSize = action.payload
      }
    })
})
